import { HpIconTypes } from '@avantia/questionset-model';

export interface HpIconWidgetProps {
  icon: HpIconTypes;
  width?: number;
}

export function IconWidget({ icon, width }: HpIconWidgetProps): JSX.Element {
  return (
    <div className="icons-panel media-left">
      <i className={`aj aj-${icon} aj-fw aj-${width || 2}x`} aria-hidden="true" />
    </div>
  );
}
